import { api, TCustomAxiosResponse } from '..';

const root = 'v1/meta';

const endpoints = {
  USStates: `${root}/us-states`,
};

export const getUSStates = async (): Promise<{ label: string; code: string }[]> => {
  const { data } = await api.get<TCustomAxiosResponse<{ label: string; code: string }[]>>(endpoints.USStates);
  const states = data.data;

  return states;
};
